<mat-tab-group animationDuration="0ms" class="tabs-contacto" #tabContacto [selectedIndex]="activeTabContacto">
    <mat-tab label="Contacto" #opcionContacto>
        <p class="contacto-text">Complete el siguiente formulario para ingresar una consulta.</p>
        <mat-grid-list cols="2" rowHeight="1:1">
            <mat-grid-tile>                
                <div class="contenido-contacto">
                    <table class="table-contacto">
                        <!-- <tr>
                            <td>Nombre</td>
                            <td><input type="text"></td>
                        </tr> --> 
                        <tr>
                            <td>Asunto</td>
                            <td> 
                                <input type="text" #asunto="ngModel" [(ngModel)]="formContacto.asunto" appEvaluaRequeridos>       
                            </td>
                        </tr>
                        <tr class="tr-error">
                            <td></td>
                            <td>                                 
                                <mat-error *ngIf="asunto.errors?.esRequerido ||formContacto.asunto ===''">Asunto es requiredo</mat-error>          
                            </td>
                        </tr>
                        <tr>
                            <td>Mensaje</td>
                            <td>                                 
                                <textarea matInput #consulta="ngModel" [(ngModel)]="formContacto.consulta" appEvaluaRequeridos></textarea>                                
                            </td>
                        </tr>
                        <tr class="tr-error">
                            <td></td>
                            <td>                                 
                                <mat-error *ngIf="consulta.errors?.esRequerido ||formContacto.consulta ===''">Asunto es requiredo</mat-error>           
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td class="td-btn"> 
                                <!-- <button mat-button class="btn-cancelar">Cancelar</button> -->
                                <button mat-button class="btn-confirmar" (click)='enviarMensaje()' [disabled]="consultaEnviada">Enviar</button>
                            </td>
                        </tr>
                    </table>
                </div>             
            </mat-grid-tile>
            <mat-grid-tile>
                <div class="informacion-contacto">
                    <p>
                        Si tiene alguna consulta respecto a la implementación del MGCEP, 
                        favor contactar al equipo de implementación al número <b>800 100 116</b> o bien escribir al correo electrónico <b>consultas_mgcep@iie.cl</b>
                    </p>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </mat-tab>
    <mat-tab label="Foro" #opcionForo>
        <p>
            En esta sección podrá ingresar consultas tanto de usabilidad de la plataforma web como técnicas referidas a todas las etapas del 
            Modelo de Gestión de Calidad de la Educación Parvularia.   
        </p>
        <p> 
            Para registrar una pregunta presione el botón "Ingresar nueva consulta" y complete todos los campos que se solicitan.
        </p>
        <p>
            Para revisar la respuesta a una consulta ya ingresada revise el historial que se desplegará más abajo.
        </p>
        
        <div class="button-row"> 
            <button mat-raised-button class="btn-nuevaConsulta" (click)="nuevaConsulta()"><mat-icon>add</mat-icon> Crear Consulta</button>
        </div>

        <div class="cargando"><mat-spinner *ngIf="cargando"></mat-spinner></div>
        <table  *ngIf="!cargando" mat-table [dataSource]="dataSource" matSort class="mat-table">
            <ng-container matColumnDef="nombre"> 
                <th mat-header-cell *matHeaderCellDef > NOMBRE </th>
                <td mat-cell *matCellDef="let element">{{element.nombre}}</td>
            </ng-container>
            <ng-container matColumnDef="enviadoPor"> 
                <th mat-header-cell *matHeaderCellDef > ENVIADO POR </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
            </ng-container>    
            <ng-container matColumnDef="asunto"> 
                <th mat-header-cell *matHeaderCellDef > ASUNTO </th>
                <td mat-cell *matCellDef="let element"> {{element.asunto}} </td>
            </ng-container>    
            <ng-container matColumnDef="cantRespuestas"> 
                <th mat-header-cell *matHeaderCellDef > RESPUESTA(S) </th>
                <td mat-cell *matCellDef="let element"> {{element.cantRespuestas}} </td>
            </ng-container>    
            <ng-container matColumnDef="fecha"> 
                <th mat-header-cell *matHeaderCellDef > FECHA ENVIO </th>
                <td mat-cell *matCellDef="let element">{{element.fecha | date:'dd-MM-y HH:mm'}} </td>
            </ng-container>    

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef> DETALLE </th>   
                <td mat-cell *matCellDef="let element"> 
                    <button mat-raised-button class="btn-verDetalle" (click)="verForo(element)">
                        Ver
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> 
        </table>
    </mat-tab> 
</mat-tab-group>
  